import { useMatchMedia } from './useMatchMedia';

/** Breakpoint widths in px used for device type detection. */
export const DEVICE_TYPE_BREAKPOINTS = {
  mobile: 768,
  tablet: 1280,
  laptop: 1650,
  desktop: 1920,
  widescreen: undefined,
} as const;

export type DeviceType = keyof typeof DEVICE_TYPE_BREAKPOINTS | 'all';

export const useDeviceType = (): DeviceType => {
  const isDesktop = useMatchMedia(`(max-width: ${DEVICE_TYPE_BREAKPOINTS.desktop}px)`);
  const isLaptop = useMatchMedia(`(max-width: ${DEVICE_TYPE_BREAKPOINTS.laptop}px)`);
  const isTablet = useMatchMedia(`(max-width: ${DEVICE_TYPE_BREAKPOINTS.tablet}px)`);
  const isMobile = useMatchMedia(`(max-width: ${DEVICE_TYPE_BREAKPOINTS.mobile}px)`);
  const isTouch = useMatchMedia('(pointer:coarse)');

  if (navigator.userAgent.toLowerCase().includes('mobile')) {
    return 'mobile';
  }

  if (isMobile && isTouch) {
    return 'mobile';
  }
  if (isTablet && isTouch) {
    return 'tablet';
  }
  if (isLaptop) {
    return 'laptop';
  }
  if (isDesktop) {
    return 'desktop';
  }
  return 'widescreen';
};

export const useIsMinWidth = (minWidthPx: number): boolean => {
  return useMatchMedia(`(min-width: ${minWidthPx}px)`);
};
